import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal, fontCondensed } from "@fdr/static-ui/Typography";
import Icon from "@fdr/static-ui/Icons";

export const VideoCardWrapper = styled.div`
  width: 280px;
  height: 250px;
  border-radius: 8px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  background: ${buildColor("white")};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const VideoPlayerContainer = styled.div<{ image?: string }>`
  width: 100%;
  height: 168px;
  position: relative;
  background: ${buildColor("navy")};
  ${({ image }) =>
    image &&
    css`
      background-image: url("${image}");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    `}
`;

export const Description = styled.div`
  width: 100%;
  background: ${buildColor("white")};
  padding: 12px;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  flex: 1 0;
`;

export const Title = styled.div`
  width: 100%;
  color: ${buildColor("navy")};
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 125%;
  font-family: ${fontNormal};
`;

export const Label = styled.p`
  text-transform: uppercase;
  color: ${buildColor("grey", "D3")};
  font-family: ${fontCondensed};
  font-size: 12px;
  line-height: 125%;
`;

export const Row = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

export const VideoDuration = styled.div`
  position: absolute;
  left: 16px;
  bottom: 16px;
  color: ${buildColor("white")};
  background-color: ${buildColor("navy")};
  padding: 1px 4px 0 4px;
  border-radius: 2px;
  font-family: ${fontCondensed};
  font-size: 12px;
  line-height: 110%;
  letter-spacing: 1px;
`;

export const PlayIcon = styled(Icon)`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;
